import { ERouting } from '@core/type';
import { FAQSearchEntity } from '@core/type/api';

import { makeServerProps } from '../../helpers/make-server-props/make-server-props';
import { useSSRPage } from '../../hooks';
import { ViewFaqSearch } from '../../view/faq/ViewFaqSearch';
import { PageFaqSearchProps } from '../../view/faq/interface-faq';

const PageFaqSearch = (props: PageFaqSearchProps) =>
  useSSRPage<FAQSearchEntity, { page: string; q: string }, unknown>({
    ...props,
    ViewPage: ViewFaqSearch,
  });

const getServerSideProps = makeServerProps({
  keyRoute: ERouting.FAQ_SEARCH,
});

export { getServerSideProps };

export default PageFaqSearch;
